///<reference path="./node.d.ts" />
// Definition of LTL AST.
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var crypto = require('crypto');
// expression
var Exp = (function () {
    function Exp() {
    }
    return Exp;
}());
exports.Exp = Exp;
// boolean constant.
var C = (function (_super) {
    __extends(C, _super);
    function C(value) {
        _super.call(this);
        this.value = value;
        this.hash = util.hash(this);
    }
    C.prototype.toLTL = function () {
        return String(this.value);
    };
    C.prototype.clone = function () {
        return new C(this.value);
    };
    C.prototype.normalize = function () {
        return this.clone();
    };
    C.prototype.fv = function () {
        return [];
    };
    return C;
}(Exp));
exports.C = C;
// prop.
var Prop = (function (_super) {
    __extends(Prop, _super);
    function Prop(name) {
        _super.call(this);
        this.name = name;
        this.hash = util.hash(this);
    }
    Prop.prototype.toLTL = function () {
        return String(this.name);
    };
    Prop.prototype.clone = function () {
        return new Prop(this.name);
    };
    Prop.prototype.normalize = function () {
        return this.clone();
    };
    Prop.prototype.fv = function () {
        return [this.name];
    };
    return Prop;
}(Exp));
exports.Prop = Prop;
// Basic 演算子.
var Not = (function (_super) {
    __extends(Not, _super);
    function Not(op) {
        _super.call(this);
        this.op = op;
        this.hash = util.hash(this);
    }
    Not.prototype.toLTL = function () {
        return '~ ' + util.atom(this.op.toLTL());
    };
    Not.prototype.clone = function () {
        return new Not(this.op.clone());
    };
    Not.prototype.normalize = function () {
        var exp = this.op.normalize();
        // 2重のnotをはずす
        if (exp instanceof Not) {
            return exp.op;
        }
        else {
            return new Not(exp);
        }
    };
    Not.prototype.fv = function () {
        return this.op.fv();
    };
    return Not;
}(Exp));
exports.Not = Not;
var Or = (function (_super) {
    __extends(Or, _super);
    function Or(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
        this.hash = util.hash(this);
    }
    Or.prototype.toLTL = function () {
        return util.atom(this.op1.toLTL()) + ' \\/ ' + util.atom(this.op2.toLTL());
    };
    Or.prototype.clone = function () {
        return new Or(this.op1.clone(), this.op2.clone());
    };
    Or.prototype.normalize = function () {
        var op1 = this.op1.normalize();
        var op2 = this.op2.normalize();
        // constになったらor/andを消せる
        if (op1 instanceof C) {
            return op1.value ? op1 : op2;
        }
        else if (op2 instanceof C) {
            return op2.value ? op2 : op1;
        }
        else {
            return new Or(op1, op2);
        }
    };
    Or.prototype.fv = function () {
        return this.op1.fv().concat(this.op2.fv());
    };
    return Or;
}(Exp));
exports.Or = Or;
var And = (function (_super) {
    __extends(And, _super);
    function And(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
        this.hash = util.hash(this);
    }
    And.prototype.toLTL = function () {
        return util.atom(this.op1.toLTL()) + ' /\\ ' + util.atom(this.op2.toLTL());
    };
    And.prototype.clone = function () {
        return new And(this.op1.clone(), this.op2.clone());
    };
    And.prototype.normalize = function () {
        var op1 = this.op1.normalize();
        var op2 = this.op2.normalize();
        if (op1 instanceof C) {
            return op1.value ? op2 : op1;
        }
        else if (op2 instanceof C) {
            return op2.value ? op1 : op2;
        }
        else {
            return new And(op1, op2);
        }
    };
    And.prototype.fv = function () {
        return this.op1.fv().concat(this.op2.fv());
    };
    return And;
}(Exp));
exports.And = And;
var Implies = (function (_super) {
    __extends(Implies, _super);
    function Implies(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
        this.hash = util.hash(this);
    }
    Implies.prototype.toLTL = function () {
        return util.atom(this.op1.toLTL()) + ' -> ' + util.atom(this.op2.toLTL());
    };
    Implies.prototype.clone = function () {
        return new Implies(this.op1.clone(), this.op2.clone());
    };
    Implies.prototype.normalize = function () {
        // p -> q (<=>) not(p) or q
        var op1 = new Not(this.op1);
        var e = new Or(op1, this.op2);
        return e.normalize();
    };
    Implies.prototype.fv = function () {
        return this.op1.fv().concat(this.op2.fv());
    };
    return Implies;
}(Exp));
exports.Implies = Implies;
var X = (function (_super) {
    __extends(X, _super);
    function X(op) {
        _super.call(this);
        this.op = op;
        this.hash = util.hash(this);
    }
    X.prototype.toLTL = function () {
        return 'X ' + util.atom(this.op.toLTL());
    };
    X.prototype.clone = function () {
        return new X(this.op.clone());
    };
    X.prototype.normalize = function () {
        return new X(this.op.normalize());
    };
    X.prototype.fv = function () {
        return this.op.fv();
    };
    return X;
}(Exp));
exports.X = X;
var F = (function (_super) {
    __extends(F, _super);
    function F(op) {
        _super.call(this);
        this.op = op;
        this.hash = util.hash(this);
    }
    F.prototype.toLTL = function () {
        return 'F ' + util.atom(this.op.toLTL());
    };
    F.prototype.clone = function () {
        return new F(this.op.clone());
    };
    F.prototype.normalize = function () {
        // F p = true U p
        var e = new U(new C(true), this.op);
        return e.normalize();
    };
    F.prototype.fv = function () {
        return this.op.fv();
    };
    return F;
}(Exp));
exports.F = F;
var G = (function (_super) {
    __extends(G, _super);
    function G(op) {
        _super.call(this);
        this.op = op;
        this.hash = util.hash(this);
    }
    G.prototype.toLTL = function () {
        return 'G ' + util.atom(this.op.toLTL());
    };
    G.prototype.clone = function () {
        return new F(this.op.clone());
    };
    G.prototype.normalize = function () {
        // G p = not (true U (not p))
        var e = new Not(new U(new C(true), new Not(this.op)));
        return e.normalize();
    };
    G.prototype.fv = function () {
        return this.op.fv();
    };
    return G;
}(Exp));
exports.G = G;
var U = (function (_super) {
    __extends(U, _super);
    function U(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
        this.hash = util.hash(this);
    }
    U.prototype.toLTL = function () {
        return util.atom(this.op1.toLTL()) + ' U ' + util.atom(this.op2.toLTL());
    };
    U.prototype.clone = function () {
        return new U(this.op1.clone(), this.op2.clone());
    };
    U.prototype.normalize = function () {
        return new U(this.op1.normalize(), this.op2.normalize());
    };
    U.prototype.fv = function () {
        return this.op1.fv().concat(this.op2.fv());
    };
    return U;
}(Exp));
exports.U = U;
var R = (function (_super) {
    __extends(R, _super);
    function R(op1, op2) {
        _super.call(this);
        this.op1 = op1;
        this.op2 = op2;
        this.hash = util.hash(this);
    }
    R.prototype.toLTL = function () {
        return util.atom(this.op1.toLTL()) + ' R ' + util.atom(this.op2.toLTL());
    };
    R.prototype.clone = function () {
        return new R(this.op1.clone(), this.op2.clone());
    };
    R.prototype.normalize = function () {
        // p R q = not ((not p) U (not q))
        var e = new Not(new U(new Not(this.op1), new Not(this.op2)));
        return e.normalize();
    };
    R.prototype.fv = function () {
        return this.op1.fv().concat(this.op2.fv());
    };
    return R;
}(Exp));
exports.R = R;
var util;
(function (util) {
    // stringがspaceを含んだら()で囲む（LTL生成用）
    function atom(str) {
        if (/\s/.test(str) && !(/^\(.*\)$/.test(str))) {
            return "(" + str + ")";
        }
        else {
            return str;
        }
    }
    util.atom = atom;
    // take hash of LTL expression
    function hash(exp) {
        var hash = crypto.createHash('md5');
        hash.update(exp.toLTL());
        return hash.digest('hex');
    }
    util.hash = hash;
})(util = exports.util || (exports.util = {}));



/*****************
 ** WEBPACK FOOTER
 ** ./dist/ast.js
 ** module id = 1
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ./dist/ast.js
 ** module id = 1
 ** module chunks = 1
 **/